// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:base-models --tenant projectReplica` to regenerate.
import DatabaseRecord from "velocious/build/src/database/record/index.js"

/**
 * Attributes accepted when creating or updating Board records.
 * @typedef {object} BoardWriteAttributes
 * @property {string} [id] - Value for the id attribute.
 * @property {string} [projectId] - Value for the projectId attribute.
 * @property {string} [name] - Value for the name attribute.
 * @property {Date | string} [createdAt] - Value for the createdAt attribute.
 * @property {Date | string} [updatedAt] - Value for the updatedAt attribute.
 * @property {Date | string | null} [lastSyncChangeAt] - Value for the lastSyncChangeAt attribute.
 */

/** @augments {DatabaseRecord<BoardWriteAttributes>} */
export default class BoardBase extends DatabaseRecord {
  /** @returns {typeof import("../models/board.js").default} */
  // @ts-ignore - override narrows return type for better IntelliSense in generated model bases
  getModelClass() { return /** @type {typeof import("../models/board.js").default} */ (this.constructor) }

  /** @returns {string} */
  id() { return this.readAttribute("id") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setId(newValue) { return this._setColumnAttribute("id", newValue) }

  /** @returns {boolean} */
  hasId() { return this._hasAttribute(this.id()) }

  /** @returns {string} */
  projectId() { return this.readAttribute("projectId") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setProjectId(newValue) { return this._setColumnAttribute("projectId", newValue) }

  /** @returns {boolean} */
  hasProjectId() { return this._hasAttribute(this.projectId()) }

  /** @returns {string} */
  name() { return this.readAttribute("name") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setName(newValue) { return this._setColumnAttribute("name", newValue) }

  /** @returns {boolean} */
  hasName() { return this._hasAttribute(this.name()) }

  /** @returns {Date} */
  createdAt() { return this.readAttribute("createdAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setCreatedAt(newValue) { return this._setColumnAttribute("createdAt", newValue) }

  /** @returns {boolean} */
  hasCreatedAt() { return this._hasAttribute(this.createdAt()) }

  /** @returns {Date} */
  updatedAt() { return this.readAttribute("updatedAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setUpdatedAt(newValue) { return this._setColumnAttribute("updatedAt", newValue) }

  /** @returns {boolean} */
  hasUpdatedAt() { return this._hasAttribute(this.updatedAt()) }

  /** @returns {Date | null} */
  lastSyncChangeAt() { return this.readAttribute("lastSyncChangeAt") }

  /**
   * @param {Date | string | null} newValue
   * @returns {void}
   */
  setLastSyncChangeAt(newValue) { return this._setColumnAttribute("lastSyncChangeAt", newValue) }

  /** @returns {boolean} */
  hasLastSyncChangeAt() { return this._hasAttribute(this.lastSyncChangeAt()) }

  /**
   * @returns {import("velocious/build/src/database/record/instance-relationships/has-many.js").default<typeof import("../models/board.js").default, typeof import("../models/board-column.js").default>}
   */
  boardColumns() { return /** @type {import("velocious/build/src/database/record/instance-relationships/has-many.js").default<typeof import("../models/board.js").default, typeof import("../models/board-column.js").default>} */ (this.getRelationshipByName("boardColumns")) }

  /**
   * @returns {Array<import("../models/board-column.js").default>}
   */
  boardColumnsLoaded() { return /** @type {Array<import("../models/board-column.js").default>} */ (this.getRelationshipByName("boardColumns").loaded()) }

  /**
   * @abstract
   * @returns {Promise<Array<import("../models/board-column.js").default>>}
   */
  loadBoardColumns() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<Array<import("../models/board-column.js").default>>}
   */
  boardColumnsOrLoad() { return /** @type {Promise<Array<import("../models/board-column.js").default>>} */ (this.relationshipOrLoad("boardColumns")) }

  /**
   * @abstract
   * @param {Array<import("../models/board-column.js").default>} newModels
   * @returns {void}
   */
  setBoardColumns(newModels) { void newModels; throw new Error("Not implemented") }

  /**
   * @returns {import("velocious/build/src/database/record/instance-relationships/has-many.js").default<typeof import("../models/board.js").default, typeof import("../models/task-board.js").default>}
   */
  taskBoards() { return /** @type {import("velocious/build/src/database/record/instance-relationships/has-many.js").default<typeof import("../models/board.js").default, typeof import("../models/task-board.js").default>} */ (this.getRelationshipByName("taskBoards")) }

  /**
   * @returns {Array<import("../models/task-board.js").default>}
   */
  taskBoardsLoaded() { return /** @type {Array<import("../models/task-board.js").default>} */ (this.getRelationshipByName("taskBoards").loaded()) }

  /**
   * @abstract
   * @returns {Promise<Array<import("../models/task-board.js").default>>}
   */
  loadTaskBoards() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<Array<import("../models/task-board.js").default>>}
   */
  taskBoardsOrLoad() { return /** @type {Promise<Array<import("../models/task-board.js").default>>} */ (this.relationshipOrLoad("taskBoards")) }

  /**
   * @abstract
   * @param {Array<import("../models/task-board.js").default>} newModels
   * @returns {void}
   */
  setTaskBoards(newModels) { void newModels; throw new Error("Not implemented") }
}
